import { Injectable } from "@angular/core";

declare var Razorpay: any;

@Injectable({
    providedIn: "root",
})
export class RazorpayService {
    options: any;
    private paymentCallback: Function = () => {};

    constructor() {}

    payWithRazorpay(
        amount: number,
        order_id: number,
        callback: (response: any) => void
    ): void {
        this.paymentCallback = callback;

        this.options = {
            key: "rzp_live_hPZD7mC7w09LUz",
            // key: "rzp_test_3TJCFQ5DltDJJg",
            amount: amount * 100,
            order_id: order_id,
            currency: "INR",
            name: "EzyCharge",
            image: "https://ezy-charge.com/wp-content/uploads/Logonew.png",
            handler: this.paymentHandler.bind(this),
            prefill: {
                name: "Dino James",
                email: "dinojames@gmail.com",
                contact: "9999999999",
            },
            notes: {
                address:
                    "EzyCharge India B2/1B Safdarjung Enclave New Delhi India",
            },
            theme: {
                color: "#F37254",
            },
        };

        const rzp = new Razorpay(this.options);
        rzp.open();
    }

    paymentHandler(response: any): void {
        // Call the passed-in callback
        if (this.paymentCallback) {
            this.paymentCallback(response);
        }
    }
}
